export const HubSpotConfig = {
  // Configuración de HubSpot Chat Widget
  portalId: '146384667', // Portal ID de HubSpot configurado
  
  // Opciones adicionales del widget
  widget: {
    // Configuración del comportamiento del widget
    openOnLoad: false, // No abrir automáticamente al cargar la página
    enableWelcomeMessage: true, // Mostrar mensaje de bienvenida
    
    // Configuración de la apariencia (si es soportada por HubSpot)
    accentColor: '#3D3DF4', // Color principal del chat (color de la marca)
    
    // Textos personalizados
    welcomeMessage: '¡Hola! ¿En qué podemos ayudarte hoy?',
    
    // Configuración de disponibilidad
    showDuringOffHours: true, // Mostrar incluso fuera del horario de oficina
  },
  
  // URL de WhatsApp para soporte (redirección directa)
  fallback: {
    whatsapp: 'https://api.whatsapp.com/message/MESTK7QPDW5HP1?autoload=1&app_absent=0',
    email: 'soporte@ardia.es', // Reemplazar con email real
    phone: '+34 XXX XXX XXX', // Reemplazar con teléfono real
  }
};

// Función helper para verificar si HubSpot está configurado
export function isHubSpotConfigured(): boolean {
  return HubSpotConfig.portalId.length > 0 && 
         HubSpotConfig.portalId !== 'YOUR_PORTAL_ID_HERE' &&
         HubSpotConfig.portalId !== '';
}
